import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';
import styled from 'styled-components';

export const ProductCardListDesktopContainer = styled.div`
  width: 100%;
  margin-bottom: 16px;

  .product-header {
    .product-title {
      width: fit-content;
      word-wrap: break-word;
      white-space: pre;
    }
  }

  .offer-info {
    justify-content: flex-start;

    .validity-info {
      flex: 0;
      text-align: left;
      align-items: flex-start;
    }

    .info-value {
      text-align: left;
    }
  }
`;

export const ProductCardListDesktopCard = styled.div`
  display: grid;
  grid-template-areas:
    'image content'
    'actions actions';
  grid-template-columns: 200px 1fr;
  grid-template-rows: auto auto;
  gap: 16px;
  padding: 16px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  align-items: start;

  > *[data-grid='image'] {
    grid-area: image;
  }
  > *[data-grid='content'] {
    grid-area: content;
  }
  > *[data-grid='actions'] {
    grid-area: actions;
    grid-column: 1 / -1;
  }

  @media (min-width: ${BREAKPOINTS.tablet}) {
    grid-template-areas: 'image content actions';
    grid-template-columns: 240px 1fr 370px;
    grid-template-rows: auto;
    gap: 20px;
    padding: 20px;

    > *[data-grid='actions'] {
      grid-column: auto;
      border-left: solid 1px #f0f0f0;
      padding-left: 16px;
      padding-right: 16px;
    }
  }
`;

export const ImageSection = styled.div`
  width: 100%;
  height: 160px;
  overflow: hidden;

  @media (min-width: ${BREAKPOINTS.tablet}) {
    height: 200px;
  }
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 160px;
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ProducerRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
`;

export const DetailsRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 8px;
  border-top: 1px solid #e6e6e6;
`;

export const ActionsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-self: start;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding-right: 16px;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    .cart-text {
      display: none !important;
    }
  }

  @media (min-width: ${BREAKPOINTS.desktop}) {
    .sale-type-grid {
      display: flex;
      gap: 0px;

      .sale-type-label {
        margin-right: 0;

        span {
          padding: 0;
          padding-right: 12px;
        }
      }

      .sale-type-divider {
        min-height: 25px;
        margin-right: 12px;
      }
    }
  }
`;

export const SelectorRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ButtonsRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: auto;
`;

export const PackingSelectWrapper = styled.div`
  .ant-select {
    .ant-select-arrow {
      border: 1px solid #f88f1f;
      border-radius: 0;
      background-color: transparent;
      right: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2px 4px;

      .anticon {
        color: #f88f1f;
        font-size: 8px;
      }
    }
  }
`;
